// note: general import
import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dropzone,
  FileMosaic,
  ImagePreview,
  FullScreen,
  VideoPreview,
} from "@files-ui/react";
import CookieConsent from "react-cookie-consent";
import { useNavigate, useLocation } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";

// note: MUI import
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";

import { selectAuthUtil, authAction } from "state/reducer/auth";

// note: component import
import { MCComboBoxBV1 } from "components/Reusable/Autocomplete";
import { MCTextFieldBV1 } from "components/Reusable/TextField";
import { MCButtonBV1 } from "components/Reusable/Button";

// note: utils
// import { WhatIsBima, blonde_man } from "utils/asset";

// note: transition
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

// ==============================|| DIALOG - RECENT ||============================== //
export function MCFullScreenDialogBV1() {
  // MC = MUI CORE
  // note: declare state.
  // const dispatch = useDispatch();
  // const detailModal = useSelector(selectDetailModal);
  // const documentDetail = useSelector(selectDocumentDetail);
  // const disciplineData = useSelector(selectDocument)?.discipline;
  // const levelData = useSelector(selectDocument)?.level;
  // const suitabilityCode = useSelector(selectDocument)?.suitability_code;
  // const reviewStatus = useSelector(selectDocument)?.review_status;

  // note: handle clode dialog.
  // const handleClose = () =>
  //   dispatch(
  //     detailAction.setDetailModal({
  //       detail_modal: { ...detailModal, isOpenRecentModal: false },
  //     })
  //   );

  return (
    <Dialog
      fullScreen
      // open={detailModal.isOpenRecentModal}
      // onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar
        sx={{
          position: "relative",
          borderRadius: "0 0 16px 16px",
        }}
      >
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            color="inherit"
            // onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{
              ml: 1,
              flex: 1,
            }}
            variant="h6"
            component="div"
          >
            {/* {documentDetail?.number} Description */}
          </Typography>
          {/* Save Button */}
          <MCButtonBV1 title={"Save"} color={"inherit"} variant={"contained"} />
        </Toolbar>
      </AppBar>
      <Grid
        container
        rowSpacing={3}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{
          margin: "1rem auto 0 auto",
          border: "1px solid red",
        }}
      >
        <Grid size={6}>
          <MCTextFieldBV1
            required={true}
            label={"Number"}
            sx={{ width: "100%" }}
            variant={"standard"}
            // value={documentDetail?.number}
          />
        </Grid>
        <Grid size={6}>
          <MCComboBoxBV1
            label={"Revision"}
            variant={"standard"}
            options={["00.00", "00.01"]}
            // value={documentDetail?.revision}
          />
        </Grid>
        <Grid sx={{ width: "100%" }}>
          <MCTextFieldBV1
            required={true}
            label={"Title"}
            // sx={{ width: "100%" }}
            variant={"standard"}
            // value={documentDetail?.document_title}
          />
        </Grid>
        <Grid size={6}>
          <MCTextFieldBV1
            required={true}
            label={"Class"}
            sx={{ width: "100%" }}
            variant={"standard"}
          />
        </Grid>
        <Grid size={6}>
          <MCComboBoxBV1
            // options={disciplineData?.map(
            //   (data) => `${data.code} - ${data.name}`
            // )}
            label={"Discipline"}
            variant={"standard"}
            // value={documentDetail?.discipline}
          />
        </Grid>
        <Grid size={6}>
          <MCComboBoxBV1
            label={"Document Review Status"}
            variant={"standard"}
            // options={reviewStatus?.map((data) => `${data.code} - ${data.name}`)}
            // value={documentDetail?.document_review_status}
          />
        </Grid>
        <Grid size={6}>
          <MCComboBoxBV1
            label={"Level"}
            variant={"standard"}
            // options={levelData?.map((data) => `${data.code} - ${data.name}`)}
            // value={documentDetail?.level}
          />
        </Grid>
        <Grid size={6}>
          <MCTextFieldBV1
            label={"Project Information Management System Link"}
            sx={{ width: "100%" }}
            variant={"standard"}
            // value={documentDetail?.project_information_management_system_link?.toLowerCase()}
          />
        </Grid>
        <Grid size={6}>
          <MCComboBoxBV1
            label={"Suitability Code"}
            variant={"standard"}
            // options={suitabilityCode?.map(
            //   (data) => `${data.code} - ${data.name}`
            // )}
            // value={documentDetail?.suitability_code}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
}

// ==============================|| DIALOG - UPLOAD FILE ||============================== //
export function UploadFileDialogBV1() {
  const dispatch = useDispatch();
  const [files, setFiles] = React.useState({
    incommingFiles: [],
    imageSource: undefined,
    videoSource: undefined,
  });

  // note: declare state
  // const checkFile = useSelector(selectCheckFile);
  // const detail = useSelector(selectDocumentTableDetail);

  // note: handle close upload file dialog
  function handleClose() {
    // dispatch(
    //   fileAction.setCheckFile({
    //     ...checkFile,
    //     isOpenAddFiles: false,
    //   })
    // );

    setFiles({
      ...files,
      incommingFiles: [],
      imageSource: undefined,
      videoSource: undefined,
    });
  }

  // note: drag and drop own custome
  // const handleListItemClick = (value) => {
  //   onClose(value);
  // };
  // const [bond, state] = useDropArea({
  //   onFiles: (files) => console.log("files", files),
  //   onUri: (uri) => console.log("uri", uri),
  //   onText: (text) => console.log("text", text),
  // });

  const updateFiles = (incommingFiles) => {
    setFiles({ ...files, incommingFiles });

    // note: developer does not use it temporarily.
    // let files = incommingFiles.map((data) => {
    //   if (data.imageUrl) {
    //     URL.revokeObjectURL(data.imageUrl);
    //   }
    //   return {
    //     ...data,
    //     imageUrl: URL.createObjectURL(data.file),
    //   };
    // });

    // note: do something with the files
    // dispatch(
    //   fileAction.setPreviewFiles({
    //     previewFiles: [...files],
    //   })
    // );
  };

  // note: remove file
  const removeFile = (id) => {
    // note: developer does not use it temporarily.
    // dispatch(
    //   fileAction.setPreviewFiles({
    //     previewFiles: previewFiles.filter((x) => x.id !== id),
    //   })
    // );

    setFiles({
      ...files,
      incommingFiles: files?.incommingFiles?.filter((data) => data?.id !== id),
    });
  };

  // note: handle see image
  const handleSee = (imageSource) => {
    setFiles({
      ...files,
      imageSource,
    });
  };

  // note: handle watch vidio
  const handleWatch = (videoSource) => {
    setFiles({
      ...files,
      videoSource,
    });
  };

  // note: upload config
  function handUploadConfig({ accessToken }) {
    return {
      url: "",
      method: "",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      cleanOnUpload: true,
    };
  }

  return (
    <Box component={"section"}>
      <Dialog onClose={handleClose}>
        <DialogTitle>
          <Stack direction={"row"} spacing={1} alignItems={"end"}>
            <Typography variant="body1">UPLOAD FILE</Typography>
            <Typography variant="caption">Document Number :</Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Dropzone
            onChange={updateFiles}
            value={files?.incommingFiles}
            style={{ minHeight: "50vh" }}
            actionButtons={{
              position: "after",
              uploadButton: { style: { textTransform: "uppercase" } },
              abortButton: {},
              cleanButton: {},
              deleteButton: {},
            }}
            uploadConfig={handUploadConfig}
          >
            {files?.incommingFiles?.map((file) => (
              <FileMosaic
                key={file.id}
                {...file}
                onDelete={removeFile}
                onSee={handleSee}
                onWatch={handleWatch}
                info
                preview
                valid
              />
            ))}
          </Dropzone>
        </DialogContent>
      </Dialog>
      <FullScreen
        open={files?.imageSource !== undefined}
        onClose={() => setFiles({ ...files, imageSource: undefined })}
      >
        <ImagePreview src={files?.imageSource} />
      </FullScreen>
      <FullScreen
        open={files?.videoSource !== undefined}
        onClose={() => setFiles({ ...files, videoSource: undefined })}
      >
        <VideoPreview src={files?.videoSource} autoPlay controls />
      </FullScreen>
    </Box>
  );
}

// ==============================|| DIALOG - COOKIE ||============================== //
export function RCCCookieModalBV1({
  cookieValue,
  cookieName = "aims-cookie",
  buttonText = "Allow all",
}) {
  // RCC = React Cookie Consent
  // React Cookie Concent
  return (
    <CookieConsent
      location="top"
      buttonText={buttonText}
      cookieName={cookieName}
      cookieValue={cookieValue}
      style={{
        background:
          "linear-gradient(90deg, #667db6 0%, #0082c8 33%, #0082c8 66%, #667db6 100%)",
      }}
      buttonStyle={{
        color: "#ffffff",
        fontSize: "10px",
        background: "linear-gradient(90deg, #11998e 0%, #38ef7d 100%)",
        borderRadius: "4px",
      }}
      expires={150}
      overlay={true}
      debug={true}
    >
      This website uses cookies to enhance the user experience.
    </CookieConsent>
  );
}

// ==============================|| DIALOG - WHAT IS BIMA ||============================== //
export function WhatIsBimDialogVB1() {
  const navigate = useNavigate();

  const location = useLocation();

  function handleCloseWhatIsBIMA() {
    navigate("/", { replace: true });
  }

  return (
    <Dialog
      fullScreen
      // open={utils?.whatIsBimaVisible}
      open={location?.hash === "#what-is-bim"}
      onClose={handleCloseWhatIsBIMA}
      scroll={"body"}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography variant="h6" sx={{ ml: 2, flex: 1 }}>
            WHAT IS BIM ?
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseWhatIsBIMA}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <img
          // src={WhatIsBima}
          style={{
            objectFit: "contain",
            width: "100%",
          }}
        />
      </DialogContent>
    </Dialog>
  );
}

export function DatePickerDialogBV1({ onClose, open, children }) {
  return (
    <Dialog onClose={onClose} open={open} fullWidth={true}>
      {children}
    </Dialog>
  );
}

export function SummaryPDFDialog({
  open = false,
  scroll = "paper",
  handleClose,
  summaryAnalyzeData,
}) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Chip
            label="BIMA AI"
            color="primary"
            avatar={
              <Avatar
                alt="Blonde Man"
                // src={blonde_man}
              />
            }
          />

          <Chip
            label={`Summary of ${summaryAnalyzeData?.fileName}`}
            color="primary"
          />
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText
          id="scroll-dialog-description"
          // ref={descriptionElementRef}
          // tabIndex={-1}
        >
          {summaryAnalyzeData?.status?.toLowerCase() === "success" ? (
            <TypeAnimation
              sequence={[summaryAnalyzeData?.value, 500]}
              speed={90}
              style={{ whiteSpace: "pre-line" }}
            />
          ) : null}

          {summaryAnalyzeData?.status?.toLowerCase() === "lowtext" ? (
            <TypeAnimation
              sequence={[summaryAnalyzeData?.value, 500]}
              speed={90}
              style={{ whiteSpace: "pre-line" }}
            />
          ) : null}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
